export default "__VITE_ASSET__7Mp9t7va__"